import { Transition } from '@unseenco/taxi'
import gsap from 'gsap'
import App from '@scripts/app'

export default class TransitionHomeGallery extends Transition {
  /**
   * Loads the destination page's assets.
   * Then starts its IN transition.
   *
   * @param {Object} params - An object containing transition parameters.
   * @param {Element} params.to - The destination page element.
   * @param {Object} params.trigger - The trigger of the page change.
   * @param {Function} params.done - This function is called when the transition is over.
   *
   * @private Called by `Highway`.
   * @returns {void}
   */
  onEnter({ to, trigger, done }) {
    gsap.set(to, { opacity: 0 })
    to.$page.load()
      .then(to.$page.prepare())
      .then(() => {
        const tl = gsap.timeline({
          onComplete: () => {
            //Force destroy in case it has not been done during transition.
            if (this.from && !this.from.$page.destroyed) this.from.$page.destroy()
            // Force remove in case it has not been done during transition.
            if (this.from && this.from.parentElement) this.from.remove()

            this.from = null

            to.$page.split()
            to.$page.letter()
            to.$page.isInit = true

            done()
          }
        })

        tl.set(this.from.$page.grid.$component.items, { clipPath: 'none' })
        tl.to(this.from.$page.grid.$component.panels, {
          duration: 1.7, y: (e, b) => {
            return (to.$page.pictures[e].pos.y - this.from.$page.grid.$component.items[e].offsetTop) + (this.from.$page.grid.$component.diffY / 2)
          }, x: (e, b) => {
            return (to.$page.pictures[e].pos.x - this.from.$page.grid.$component.items[e].offsetLeft) + (this.from.$page.grid.$component.diffX / 2)
          }, scaleX: (e, b) => {
            return to.$page.pictures[e].pos.width / this.from.$page.grid.$component.items[e].offsetWidth
          }, scaleY: (e, b) => {
            return to.$page.pictures[e].pos.height / this.from.$page.grid.$component.items[e].offsetHeight
          }, ease: 'power2.inOut', stagger: {
            from: 'end', amount: 0.5
          }
        })

        tl.addLabel('step1')
        tl.to(to, { duration: 1, opacity: 1, ease: 'power2.out' }, 'step1')
      })
  }

  /**
   * Starts the source page's OUT transition.
   *
   * @param {Object} params - An object containing transition parameters.
   * @param {Element} params.from - The source page element.
   * @param {Object} params.trigger - The trigger of the page change.
   * @param {Function} params.done - This function is called when the transition is over.
   *
   * @private Called by `Highway`.
   * @returns {void}
   */
  onLeave({ from, trigger, done }) {
    App.locked(true)
    this.from = from

    const tl = gsap.timeline({
      onComplete: done
    })

    tl.add(this.from.$page.disappearToGallery())
  }
}
